import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent } from '../components/ui/card';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Verify() {
  const { serial } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/verify/${serial}`)
      .then(r => setData(r.data))
      .catch(() => setData({ valid: false, reason: 'network_error' }))
      .finally(() => setLoading(false));
  }, [serial]);

  if (loading) return <div className="min-h-screen flex items-center justify-center">Checking…</div>;

  const bg = data.valid ? 'bg-emerald-50' : 'bg-red-50';
  const icon = data.valid ? '✅' : '❌';
  const headline = data.valid ? 'Valid membership' : 'Not a valid membership';

  return (
    <div className={`min-h-screen ${bg} flex items-center justify-center px-4 py-10`}
         data-testid="verify-page">
      <Card className="w-full max-w-md">
        <CardContent className="p-6 space-y-3 text-center">
          <div className="text-6xl">{icon}</div>
          <h1 className="text-2xl font-bold" data-testid="verify-headline">{headline}</h1>
          {data.valid ? (
            <div className="text-left text-sm space-y-1 pt-2 border-t mt-3">
              <div><strong>Student:</strong> {data.student_name}</div>
              <div><strong>Grade:</strong> {data.grade}</div>
              <div><strong>School:</strong> {data.school}</div>
              <div><strong>District:</strong> {data.district}</div>
              <div><strong>Serial:</strong> {data.serial}</div>
              <div><strong>Paid until:</strong> {(data.paid_until || '—').slice(0, 10)}</div>
            </div>
          ) : (
            <p className="text-sm text-red-800" data-testid="verify-reason">
              Reason: <strong>{data.reason}</strong>. Please contact Genius One Plus for support.
            </p>
          )}
          <p className="text-xs text-muted-foreground pt-3">
            Powered by Genius One Plus — Grade 6 transition programme.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
